import { lazy } from "react";

// project imports
import MainLayout from "../layout/MainLayout";
// import Users from '../views/users';
import Loadable from "./../components/Loadable";
import ProtectedRoute from "../components/ProtectedRoute";
import NotFound from "../views/404";
import Categories from "../views/pages/categories";
import SubCategories from "../views/pages/subCategories";
import Pos from "../views/POS";
import Group from "../views/management/groups";
import Banner from "../views/management/banners";
import Items from "../views/items";
import Pins from "../views/pins";
import Notification from "../views/notification";
import Profile from "../views/users/profile";
import Operation from "../views/operation";
import Wallets from "../views/wallets";
import Transactions from "../views/wallets/transactions";
import PointsTransactions from "../views/wallets/pointsTransactions";
import RequestPoints from "../views/request-points";
import RepDetails from "../views/reports/repDetails";
import OrdersReport from "../views/reports/orders";
import Supplier from "../views/supplier-bills/suppliers";
import SupplierTransactions from "../views/supplier-bills/suppliers/supplierTransactions";
import Bills from "../views/supplier-bills/bills";
import Expense from "../views/expense";
import ExternalRevenue from "../views/externalRevenue";
import TotalRevenue from "../views/reports/totalRevenue";
import CashReport from "../views/reports/cash";
import TotalsReport from "../views/reports/totals";
import Provinces from "../views/management/provinces/province";
import StockReport from "../views/reports/stock";
import OperationTransfer from "../views/balanceTransfer/operationTransfer";
import Products from "../views/platform/products";
import ProductSupplier from "../views/platform/productsSupplier";
import ProductSupplierTransactions from "../views/platform/productsSupplier/transactions";
import ProductsOrders from "../views/platform/productOrders";
import SimCard from "../views/balanceTransfer/simCard";
import Sms from "../views/balanceTransfer/sms";
import Tickets from "../views/tickets";
import TicketDetails from "../views/tickets/home/details";
import Cards from "../views/payments/cards";
import OrderRechargeCards from "../views/payments/orderRechargeCards";
import IssuedCard from "../views/payments/issuedCard";
import Investors from "../views/supplier-bills/investors";
import CapitalAmount from "../views/supplier-bills/capital-amount";
import AsiaBills from "../views/asiaBills";
import EpaymentTransactions from "../views/payments/transactions";
import JCategories from "../views/jomla/category";
import JItems from "../views/jomla/items";
import JSupplier from "../views/jomla/supplier";
import PosLayout from "../layout/PosLayout";
import JInvoices from "../views/jomla/Invoice";
import JOrder from "../views/jomla/orders";
import ExternalOrder from "../views/pos_dashboard/externalOrders";
import JOrderDetails from "../views/jomla/orders/home/table/orderDetails";
import JReport from "../views/jomla/reports";
import JSafe from "../views/jomla/safe";
import JTransaction from "../views/jomla/supplier/supplierTransactions";
import JPos from "../views/jomla/pos";
import Settings from "../views/settings";
import PosType from "../views/management/posType";
import PlatformPayments from "../views/reports/platformPayments";
import PosEPayments from "../views/reports/posEPayments";
import LazyPos from "../views/reports/lazyPos";
import PosField from "../views/management/posFields";
import JGroup from "../views/jomla/jGroup";
import JExpense from "../views/jomla/expense";
import JMonthlyTarget from "../views/jomla/monthlyTarget";
import ContactPerson from "../views/contactPerson";
import OrdersAndTransferBalance from "../views/orders";
import TeamLeaderOrdersPerDaysChart from "../views/reports/teamLeaderOrdersPerDays";

// dashboard routing
const Home = Loadable(lazy(() => import("../views/home")));
const Users = Loadable(lazy(() => import("../views/users")));

const NonePos = Loadable(lazy(() => import("../views/nonePos")));
const Welcome = Loadable(lazy(() => import("../views/Welcome")));

// Statistics
const PosSalesPerWeekChart = Loadable(
  lazy(() => import("../views/ordersStatistics/posOrdersPerWeek")),
);
const RepSalesPerWeekChart = Loadable(
  lazy(() => import("../views/ordersStatistics/repOrdersPerWeek")),
);
const RepPosEPaymentsChart = Loadable(
  lazy(() => import("../views/ordersStatistics/repPosEPayments")),
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = [
  {
    path: "/app",
    element: <MainLayout />,
    children: [
      {
        path: "/app",
        element: (
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/welcome",
        element: (
          <ProtectedRoute>
            <Welcome />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/statistics/",
        children: [
          {
            path: "/app/statistics/pos_orders",
            element: (
              <ProtectedRoute>
                <PosSalesPerWeekChart />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/statistics/rep_orders",
            element: (
              <ProtectedRoute>
                <RepSalesPerWeekChart />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/statistics/rep_pos_e_payments",
            element: (
              <ProtectedRoute>
                <RepPosEPaymentsChart />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/users",
        element: (
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/user/Profile",
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/pos",
        element: (
          <ProtectedRoute>
            <Pos />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/request_points",
        element: (
          <ProtectedRoute>
            <RequestPoints />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/none_pos",
        element: (
          <ProtectedRoute>
            <NonePos />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/items",
        element: (
          <ProtectedRoute>
            <Items />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/suppliers&bills/",
        children: [
          {
            path: "/app/suppliers&bills/suppliers",
            element: (
              <ProtectedRoute>
                <Supplier />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/suppliers&bills/suppliers/transactions/:supplier_id",
            element: (
              <ProtectedRoute>
                <SupplierTransactions />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/suppliers&bills/bills",
            element: (
              <ProtectedRoute>
                <Bills />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/suppliers&bills/Investors",
            element: (
              <ProtectedRoute>
                <Investors />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/suppliers&bills/capital-amount",
            element: (
              <ProtectedRoute>
                <CapitalAmount />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/pins",
        children: [
          {
            path: "/app/pins/pins/:item_id",
            element: (
              <ProtectedRoute>
                <Pins />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/pins/pins",
            element: (
              <ProtectedRoute>
                <Pins />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/pins/operations",
            element: (
              <ProtectedRoute>
                <Operation />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/notification",
        element: (
          <ProtectedRoute>
            <Notification />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/orders",
        element: (
          <ProtectedRoute>
            <OrdersAndTransferBalance />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/expense",
        element: (
          <ProtectedRoute>
            <Expense />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/contact-person",
        element: (
          <ProtectedRoute>
            <ContactPerson />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/external_revenue",
        element: (
          <ProtectedRoute>
            <ExternalRevenue />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/asia_bills",
        element: (
          <ProtectedRoute>
            <AsiaBills />
          </ProtectedRoute>
        ),
      },
      {
        path: "/app/sim_card_transfer",
        children: [
          {
            path: "/app/sim_card_transfer/sim_card",
            element: (
              <ProtectedRoute>
                <SimCard />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/sim_card_transfer/operation_transfer",
            element: (
              <ProtectedRoute>
                <OperationTransfer />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/sim_card_transfer/received_sms",
            element: (
              <ProtectedRoute>
                <Sms />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/wallets",
        children: [
          {
            path: "/app/wallets",
            element: (
              <ProtectedRoute>
                <Wallets />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wallets/transactions/:user_id",
            element: (
              <ProtectedRoute>
                <Transactions />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wallets/pos-transactions",
            element: (
              <ProtectedRoute>
                <PointsTransactions />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/pages",
        children: [
          {
            path: "/app/pages/categories",
            element: (
              <ProtectedRoute>
                <Categories />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/pages/sub_categories",
            element: (
              <ProtectedRoute>
                <SubCategories />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/management",
        children: [
          {
            path: "/app/management/banner",
            element: (
              <ProtectedRoute>
                <Banner />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/management/groups",
            element: (
              <ProtectedRoute>
                <Group />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/management/provinces",
            element: (
              <ProtectedRoute>
                <Provinces />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/management/pos_types",
            element: (
              <ProtectedRoute>
                <PosType />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/management/pos_field",
            element: (
              <ProtectedRoute>
                <PosField />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/reports",
        children: [
          {
            path: "/app/reports/representative_details",
            element: (
              <ProtectedRoute>
                <RepDetails />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/reports/orders",
            element: (
              <ProtectedRoute>
                <OrdersReport />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/reports/total_revenue",
            element: (
              <ProtectedRoute>
                <TotalRevenue />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/reports/cash",
            element: (
              <ProtectedRoute>
                <CashReport />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/reports/totals",
            element: (
              <ProtectedRoute>
                <TotalsReport />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/reports/stock",
            element: (
              <ProtectedRoute>
                <StockReport />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/reports/platform_payments",
            element: (
              <ProtectedRoute>
                <PlatformPayments />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/reports/pos_e_payments",
            element: (
              <ProtectedRoute>
                <PosEPayments />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/reports/lazy_pos",
            element: (
              <ProtectedRoute>
                <LazyPos />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/reports/team-leader-orders-per-days",
            element: (
              <ProtectedRoute>
                <TeamLeaderOrdersPerDaysChart />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/platform",
        children: [
          {
            path: "/app/platform/products",
            element: (
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/platform/product_supplier",
            children: [
              {
                path: "/app/platform/product_supplier",
                element: (
                  <ProtectedRoute>
                    <ProductSupplier />
                  </ProtectedRoute>
                ),
              },
              {
                path: "/app/platform/product_supplier/transactions/:product_supplier_id",
                element: (
                  <ProtectedRoute>
                    <ProductSupplierTransactions />
                  </ProtectedRoute>
                ),
              },
            ],
          },
          {
            path: "/app/platform/products_orders",
            element: (
              <ProtectedRoute>
                <ProductsOrders />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/tickets",
        children: [
          {
            path: "/app/tickets",
            element: (
              <ProtectedRoute>
                <Tickets />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/tickets/tickets/:ticket_id",
            element: (
              <ProtectedRoute>
                <TicketDetails />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/payments",
        children: [
          {
            path: "/app/payments/cards",
            element: (
              <ProtectedRoute>
                <Cards />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/payments/order-recharge-cards",
            element: (
              <ProtectedRoute>
                <OrderRechargeCards />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/payments/issued_card",
            element: (
              <ProtectedRoute>
                <IssuedCard />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/payments/epayment_transactions",
            element: (
              <ProtectedRoute>
                <EpaymentTransactions />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/app/settings",
        element: (
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        ),
      },
      // ------------- wholesale ----------------
      {
        path: "/app/wholesale",
        children: [
          {
            path: "/app/wholesale/j_pos",
            element: (
              <ProtectedRoute>
                <JPos />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/group",
            element: (
              <ProtectedRoute>
                <JGroup />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/categories",
            element: (
              <ProtectedRoute>
                <JCategories />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/items",
            element: (
              <ProtectedRoute>
                <JItems />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/supplier",
            element: (
              <ProtectedRoute>
                <JSupplier />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/invoice",
            element: (
              <ProtectedRoute>
                <JInvoices />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/supplier_transactions/:supplier_id",
            element: (
              <ProtectedRoute>
                <JTransaction />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/orders",
            element: (
              <ProtectedRoute>
                <JOrder />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/order/:order_id",
            element: (
              <ProtectedRoute>
                <JOrderDetails />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/reports",
            element: (
              <ProtectedRoute>
                <JReport />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/safe",
            element: (
              <ProtectedRoute>
                <JSafe />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/expense",
            element: (
              <ProtectedRoute>
                <JExpense />
              </ProtectedRoute>
            ),
          },
          {
            path: "/app/wholesale/monthly_target",
            element: (
              <ProtectedRoute>
                <JMonthlyTarget />
              </ProtectedRoute>
            ),
          },
        ],
      },
      // Catch-all route for 404 within /app routes
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  {
    path: "/pos",
    element: <PosLayout />,
    children: [
      {
        path: "/pos/external-orders",
        element: (
          <ProtectedRoute>
            <ExternalOrder />
          </ProtectedRoute>
        ),
      },
      // Catch-all route for 404 within /pos routes
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  // Catch-all route for any other unmatched routes
  {
    path: "*",
    element: <NotFound />,
  },
];

export default MainRoutes;
